import { PlatformNames } from "../constants";

export enum TargetPlatforms {
  xboxSeriesXS = "xboxSeriesXS",
  xboxOne = "xboxOne",
  windowsStore = "windowsStore",
  steam = "steam",
  epic = "epic",
  gog = "gog",
  pc = "pc",
  nintendoSwitch2 = "nintendoSwitch2",
  nintendoSwitch = "nintendoSwitch",
  ps5 = "ps5",
  ps4 = "ps4",
  android = "android",
  ios = "ios",
  other = "other",
}

export const TargetPlatformsDisplayName = {
  [TargetPlatforms.xboxSeriesXS]: PlatformNames.XboxSeriesXS,
  [TargetPlatforms.xboxOne]: PlatformNames.XboxOne,
  [TargetPlatforms.windowsStore]: PlatformNames.WindowsStore,
  [TargetPlatforms.steam]: PlatformNames.Steam,
  [TargetPlatforms.epic]: PlatformNames.Epic,
  [TargetPlatforms.gog]: PlatformNames.GOG,
  [TargetPlatforms.pc]: PlatformNames.PC,
  [TargetPlatforms.nintendoSwitch2]: PlatformNames.NintendoSwitch2,
  [TargetPlatforms.nintendoSwitch]: PlatformNames.NintendoSwitch,
  [TargetPlatforms.ps5]: PlatformNames.PS5,
  [TargetPlatforms.ps4]: PlatformNames.PS4,
  [TargetPlatforms.android]: PlatformNames.Android,
  [TargetPlatforms.ios]: PlatformNames.iOS,
};
